<script setup lang="ts">
import { onMounted } from "vue";
import { useAppStore } from "@/stores/app";
import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";
//@ts-ignore
import HamburgerButton from "@/components/elements/hamburger-button.vue";

const breakpoints = useBreakpoints(breakpointsTailwind);

const showPageLinks = breakpoints.greater("lg");
const showHamburgerButton = breakpoints.smaller("lg");

const appStore = useAppStore();

interface Link {
    link: {
        class: string;
        target: string;
        title: string;
        url: string;
    };
}

const props = defineProps<{ links?: Link[]; uri: string; contactLinks?: Link[]; firstSection?: { bg_color: string } }>();

const isActive = (link: string) => {
    if(link === '/wonen' && props.uri.includes('panden')){
        return true;
    }

    if(link === '/projecten' && props.uri.includes('projecten/')){
        return true;
    }
    
    return (props.uri !== "/" && link.includes(props.uri)) || (props.uri === "/" && link === "/");
};

onMounted(() => {
    let last_known_scroll_position = 0;
    let ticking = false;

    window.addEventListener("scroll", function () {
        last_known_scroll_position = window.scrollY;	

        if (!ticking) {
            window.requestAnimationFrame(function () {
                if (last_known_scroll_position > 50) {
                    appStore.navigation.header.sticky = true;
                } else {
                    appStore.navigation.header.sticky = false;
                }

                ticking = false;
            });

            ticking = true;
        }
    });
});
</script>

<template>
    <transition name="fade" appear>
        <div class="top-0 z-50" :class="[`${appStore.navigation.header.sticky ? 'sticky' : 'not-sticky'}`, { 'slideout-visible': appStore.navigation.slideout.visible }]">
            <header id="contact-navigation" class="top-nav bg-brown-200 py-[4px] hidden lg:block">
                <div v-if="showPageLinks" class="container flex justify-end">
                    <div v-if="contactLinks" class="flex flex-wrap gap-[51px] text-14 font-helv font-medium text-beige-200">
                        <a v-for="page in contactLinks" :href="page.link.url" :target="page.link.target" :class="[page.link.class, { 'shadow-nav': isActive(page.link.url) }]" v-html="page.link.title"></a>
                    </div>
                </div>
            </header>
            <header id="main-navigation" ref="header" class="main-nav py-[35px] lg:py-[45px] bg-beige-200 " :class="[firstSection?.bg_color ?? '!bg-beige-200', { 'lg:bg-white': appStore.navigation.header.sticky }]">
                <div class="container flex justify-between items-center">
                    <transition name="fade">
                        <div>
                            <a href="/" class="mr-auto" v-if="!appStore.navigation.slideout.visible">
                                <svg-vue icon="logo" class="w-auto h-[38px] fill-brown-100"></svg-vue>
                                <span class="sr-only">{{ appStore.appName }}</span>
                            </a>
                        </div>
                    </transition>
                    <transition name="fade">
                        <div v-if="links && showPageLinks" class="hidden lg:flex flex-wrap gap-[40px] text-18 font-helv font-medium">
                            <a v-for="page in links" :href="page.link.url" :target="page.link.target" class="hover:shadow-nav transition-shadow" :class="[page.link.class, { 'shadow-nav': isActive(page.link.url) }]" v-html="page.link.title"></a>
                        </div>
                    </transition>
                    <hamburger-button class="ml-auto lg:hidden"></hamburger-button>
                </div>
            </header>
        </div>
    </transition>
</template>

<style scoped>
header .sticky {
    box-shadow: inset 0 -1px 0 0 #d8d8d8;
    @apply bg-white;
}

header .slideout-visible {
    box-shadow: none;
    @apply bg-none;
}
</style>
